import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const UpdatesIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 30,
  height = 30,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g id="updates">
          <path
            d="M0,15 C0,23.284 6.716,30 15,30 C23.284,30 30,23.284 30,15 C30,6.716 23.284,0 15,0 C6.716,0 0,6.716 0,15"
            fill="#57B348"
            id="Fill-1"
          ></path>
          <path
            d="M12.7326,18.6901 L10.0826,19.9751 C9.6766,20.1721 9.1886,20.0031 8.9926,19.5971 L6.9466,15.3791 C6.7496,14.9741 6.9196,14.4861 7.3246,14.2891 L9.9746,13.0041 C10.3806,12.8071 10.8686,12.9761 11.0656,13.3821 L13.1106,17.6001 C13.3076,18.0051 13.1386,18.4931 12.7326,18.6901"
            fill="#ffffff"
            className={styles.white}
            id="Fill-3"
          ></path>
          <path
            d="M12.7326,18.6901 L10.0826,19.9751 C9.6766,20.1721 9.1886,20.0031 8.9926,19.5971 L6.9466,15.3791 C6.7496,14.9741 6.9196,14.4861 7.3246,14.2891 L9.9746,13.0041 C10.3806,12.8071 10.8686,12.9761 11.0656,13.3821 L13.1106,17.6001 C13.3076,18.0051 13.1386,18.4931 12.7326,18.6901 Z"
            id="Stroke-5"
            stroke="#FFFFFF"
            className={styles.whiteStroke}
            strokeLinejoin="round"
          ></path>
          <path
            d="M8.0693,19.9804 L8.9003,19.5774 C9.1963,19.4334 9.3203,19.0774 9.1763,18.7814 L7.8503,16.0474 C7.7073,15.7514 7.3503,15.6284 7.0543,15.7714 L6.2233,16.1744 C5.9273,16.3184 5.8043,16.6744 5.9473,16.9704 L7.2733,19.7044 C7.4173,20.0004 7.7733,20.1244 8.0693,19.9804"
            fill="#ffffff"
            className={styles.white}
            id="Fill-7"
          ></path>
          <path
            d="M8.0693,19.9804 L8.9003,19.5774 C9.1963,19.4334 9.3203,19.0774 9.1763,18.7814 L7.8503,16.0474 C7.7073,15.7514 7.3503,15.6284 7.0543,15.7714 L6.2233,16.1744 C5.9273,16.3184 5.8043,16.6744 5.9473,16.9704 L7.2733,19.7044 C7.4173,20.0004 7.7733,20.1244 8.0693,19.9804 Z"
            id="Stroke-9"
            stroke="#FFFFFF"
            className={styles.whiteStroke}
            strokeLinejoin="round"
          ></path>
          <path
            d="M10.0186,14.0121 C10.0186,14.0121 14.5886,11.0871 15.7296,6.7341 L21.4326,18.4261 C21.4326,18.4261 17.4286,16.2781 11.9786,17.9881 L10.0186,14.0121 Z"
            fill="#ffffff"
            className={styles.white}
            id="Fill-11"
          ></path>
          <path
            d="M10.0186,14.0121 C10.0186,14.0121 14.5886,11.0871 15.7296,6.7341 L21.4326,18.4261 C21.4326,18.4261 17.4286,16.2781 11.9786,17.9881 L10.0186,14.0121 Z"
            id="Stroke-13"
            stroke="#FFFFFF"
            className={styles.whiteStroke}
            strokeLinejoin="round"
          ></path>
          <path
            d="M19.8472,8.8956 C19.8472,8.8956 22.5742,10.1836 21.9512,13.4586"
            id="Stroke-15"
            stroke="#FFFFFF"
            className={styles.whiteStroke}
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M21.1879,6.7116 C21.1879,6.7116 25.6699,8.8516 24.5869,13.9456"
            id="Stroke-17"
            stroke="#FFFFFF"
            className={styles.whiteStroke}
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M9.7451,19.4896 L13.3421,23.8416 C13.5171,24.0526 13.8141,24.1166 14.0601,23.9976 L15.1181,23.4846 C15.5091,23.2946 15.6221,22.7916 15.3501,22.4536 L12.0781,18.3906 L9.7451,19.4896 Z"
            fill="#ffffff"
            className={styles.white}
            id="Fill-19"
          ></path>
          <path
            d="M9.7451,19.4896 L13.3421,23.8416 C13.5171,24.0526 13.8141,24.1166 14.0601,23.9976 L15.1181,23.4846 C15.5091,23.2946 15.6221,22.7916 15.3501,22.4536 L12.0781,18.3906 L9.7451,19.4896 Z"
            id="Stroke-21"
            stroke="#FFFFFF"
            className={styles.whiteStroke}
            strokeLinejoin="round"
          ></path>
        </g>
      </g>
    </Icon>
  )
}
